export const ROW_RENDER_STAGGER = 7.5;

export const ROW_EMPTY_CELL = 'row-empty-cell';
